import moment from 'moment';
import numeral from 'numeral';
import 'numeral/locales/es-es';
import {
  ALL_OPTIONS,
  BACKEND_DF,
  FRONT_DF_1,
  TIPO_ENDOSO_EMISION_ID,
  TIPO_ENDOSO_MODIFICACION_ID,
  TIPO_ENDOSO_RENOVACION_ID,
  ROLES_CORREDOR,
  ROLES_ASEGURADO,
} from '../CONST';

numeral.locale('es-es');

const extratFilenameFromContentDisposition = content => {
  return content.includes('filename=')
    ? content.split('filename=')[1].replace(/^"+|"+$/g, '')
    : decodeURI(content.split('filename*=utf-8\'\'')[1].replace(/^"+|"+$/g, ''));
};

const extractFilenameFromUrl = url => url.split('/').pop();

export const fileDownload = (url, loginIdToken, callback) => {
  if (url === "/") {
    if (callback) callback();
    return;
  }
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader('Authorization', `JWT ${loginIdToken}`);
  xhr.onload = function onload() {
    if (this.status === 200) {
      const content = xhr.getResponseHeader('Content-Disposition');
      const filename = content
        ? extratFilenameFromContentDisposition(content)
        : extractFilenameFromUrl(url);
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(new Blob([this.response]));
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
      }, 1000);
    }
    if (callback)
      callback();
  };
  xhr.send();
};

// Lista de archivos que el navegador puede mostrar
const DISPLAYABLE_TYPES = [
  'text/plain',
  'application/pdf',
  'image/',
  'text/html',
  'application/json'
];

export const fileOpenOrDownload = (url, loginIdToken, callback, filename) => {
  if (url === "/") {
    if (callback) callback();
    return;
  }

  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.setRequestHeader('Authorization', `JWT ${loginIdToken}`);
  
  xhr.onload = function() {
    if (this.status === 200) {
      const blob = this.response;
      const contentType = blob.type;
      const contentDisposition = xhr.getResponseHeader('Content-Disposition');
      
      const extractedName = contentDisposition 
        ? extratFilenameFromContentDisposition(contentDisposition)
        : extractFilenameFromUrl(url);
      const finalFilename = filename || extractedName;

      const isDisplayable = DISPLAYABLE_TYPES.some(type => contentType.startsWith(type));

      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      if (isDisplayable) {
        link.href = blobUrl;
        link.target = '_blank';
      } else {
        link.href = blobUrl;
        link.download = finalFilename;
      }

      document.body.appendChild(link);
      link.click();
      
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 10000);
    }
    
    if (callback) callback();
  };
  
  xhr.send();
};

export const fdate = (date, format = FRONT_DF_1) => date ? moment(date).format(format) : '';

export const isValidDate = (date, format = FRONT_DF_1) => moment(date, format, true).isValid();

export const pluralize = (text, number, suffix = 's') => number > 1 ? `${number} ${text}${suffix}` : `${number} ${text}`;

export const roundFloat = (value, decimals = 2) => {
  const format = '0,0.'.padEnd(decimals + 4, '0');
  const safeValue = Math.abs(value) < 1e-6 ? 0 : value;
  return numeral(safeValue).format(format);
};

export const roundInt = (value) => {
  return numeral(value).format();
};

export const tipoEndosoLabels = {
  [TIPO_ENDOSO_EMISION_ID]: 'Emisión',
  [TIPO_ENDOSO_RENOVACION_ID]: 'Renovación',
  [TIPO_ENDOSO_MODIFICACION_ID]: 'Endoso',
};

export const buildFilterParams = (state, dateFields=[], charFields=[]) => {
  let filterParams = `page=${state.page + 1}&`;
  if (state.filtered.length) {
    state.filtered.forEach((node) => {
      let validFilter = false;
      let filterValue = node.value;

      if (typeof node.value === 'number' && node.value > 0) {
        validFilter = true;
      } else if (typeof node.value === 'string' && node.value.length > 2 && node.value !== ALL_OPTIONS) {
        validFilter = true;

        if (dateFields.includes(node.id)) {
          const date = moment(filterValue, FRONT_DF_1, true);
          if (date.isValid()) {
            filterValue = date.format(BACKEND_DF);
          } else {
            validFilter = false;
          }
        }
      } else if (charFields.includes(node.id) && node.value !== ALL_OPTIONS) {
        if (node.id === 'deudor_name' || node.id === 'deudor_rut') {
          if (node.value.length > 2) {
            validFilter = true;
          } else {
            validFilter = false;
          }
        } else {
          validFilter = true;
        }
      }
      if (validFilter) {
        filterParams = `${filterParams}${node.id}=${filterValue}&`;
      }
    });
  }
  if (state.sorted.length) {
    let ordering = 'ordering=';
    const node = state.sorted[0];
    const field = node.id.replace('__icontains', '');
    ordering = !node.desc ? `${ordering}${field}` : `${ordering}-${field}`;
    filterParams = `${filterParams}${ordering}`;
  }
  return filterParams;
};

export const externalUserHasRole = (user, roles) =>
  roles.some(role => user.roles.includes(role));

export const userHasRole = (user, roles) =>
  roles.some(role => user.roles.includes(role)) || user.is_orsan;

export const intermediaryAccess = (user) => (
  userHasRole(user, ROLES_CORREDOR) && !userHasRole(user, ROLES_ASEGURADO) && !user.is_orsan
);

export const isAsegurado = (user) => userHasRole(user, ROLES_ASEGURADO) && !user.is_orsan

export const bytesToMb = (number) => (number / 1024 / 1024).toFixed(2);

export const mbToBytes = (number) => number * 1024 * 1024;

export const apelable = (fechaRespuesta) => {
  const fechaHoy = moment();
  const momentRespuesta = moment(fechaRespuesta, 'DD-MM-YYYY')
  const deltaDias = fechaHoy.diff(momentRespuesta, 'days')
  return deltaDias <= 30
}
